import { useForm } from "react-hook-form";
import { registerService, toSession } from "../services/authenticationService";
import { useAuthContext } from "../context/AuthProvider";
import { useNavigate, useLocation, Link } from "react-router-dom";
import logo from "../assets/img/logo.jpg";
import "../assets/style/auth.css";
import Loader from "../components/shared/Loader";
import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { useState } from "react";

export default function App(){
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuthContext();

    // Destino tras registrarse: la sala o el perfil desde donde llegó el visitante.
    const next = new URLSearchParams(location.search).get('next');

    const [loading, setLoading] = useState(false);
    const [serverError, setServerError] = useState('');

    useDocumentMeta({ title: "Crear cuenta", noIndex: true });
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm();

    const onSubmit = async (body) => {
        setLoading(true);
        setServerError('');
        try {
            const result = await registerService(body);
            if (result?.user) {
                login(toSession(result));
                navigate(next || '/live', { replace: true });
            } else {
                setServerError('No fue posible crear la cuenta. Intenta nuevamente.');
            }
        } catch (error) {
            setServerError(error?.message || 'No fue posible crear la cuenta.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <Loader loading={loading} message="Creando cuenta" />
            <Link to="/" className="back-home">
                <i className="fas fa-arrow-left"></i> Volver al Inicio
            </Link>
            
            <div className="auth-card">
                <div className="auth-header">
                    <img src={logo} alt="Afrodita Logo" className="auth-logo" />
                    <h2 className="auth-title">Regístrate</h2>
                    <p className="auth-subtitle">
                        {next
                            ? 'Crea tu cuenta gratis para entrar al show en vivo'
                            : 'Crea tu cuenta en Afrodita'}
                    </p>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
                    {serverError && (
                        <div className="alert alert-danger py-2 small" role="alert">
                            <i className="fas fa-circle-exclamation me-2"></i>{serverError}
                        </div>
                    )}
                    <div className="form-group mb-3">
                        <label className="form-label">Nombre Completo</label>
                        <div className="auth-input-group">
                            <i className="fas fa-user"></i>
                            <input 
                                type="text" 
                                {...register("name", { required: true })} 
                                className="auth-input" 
                                placeholder="Tu nombre artístico" 
                            />
                        </div>
                        {errors.name && <small className="text-danger d-block mb-2">Este campo es requerido</small>}
                    </div>

                    <div className="form-group mb-3">
                        <label className="form-label">Correo Electrónico</label>
                        <div className="auth-input-group">
                            <i className="fas fa-envelope"></i>
                            <input 
                                type="email" 
                                {...register("email", { required: true })} 
                                className="auth-input" 
                                placeholder="tu@email.com" 
                            />
                        </div>
                        {errors.email && <small className="text-danger d-block mb-2">Este campo es requerido</small>}
                    </div>

                    <div className="form-group mb-3">
                        <label className="form-label">Contraseña</label>
                        <div className="auth-input-group">
                            <i className="fas fa-lock"></i>
                            <input 
                                type="password" 
                                {...register("password", { required: true })} 
                                className="auth-input" 
                                placeholder="Crea una contraseña fuerte" 
                            />
                        </div>
                        {errors.password && <small className="text-danger d-block mb-2">Este campo es requerido</small>}
                    </div>

                    <button type="submit" className="auth-btn" disabled={!isValid}>
                        Crear Cuenta
                    </button>

                    <div className="auth-footer">
                        <span>¿Ya tienes una cuenta?</span>
                        <Link
                            to={next ? `/login?next=${encodeURIComponent(next)}` : '/login'}
                            className="auth-link ms-2"
                        >
                            Inicia Sesión
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}